var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Node',{staticClass:"action-node",attrs:{"node-id":_vm.nodeId,"icon":_vm.currentIcon,"shape":"trapezoid"}})}
var staticRenderFns = []

export { render, staticRenderFns }